import moment from 'moment';
import { EVENTS } from 'common/domain/constants';

class CalendarInlineHeaderController {
  constructor($rootScope, $scope, $timeout) {
    'ngInject';
    this.rootScope = $rootScope;
    this.scope = $scope;
    this.timeout = $timeout;
  }

  $onInit() {
    this.month = this.date.getMonth();
    this.year = this.date.getFullYear();
    this.momentDate = moment(this.date);
    this.momentDate.locale('es');
    this.monthName = this.momentDate.format('MMMM YYYY');
    this.weekdays = this._startWeekDayNames();
    this._initComponentDays();

    this.scope.$on(EVENTS.CALENDAR_INLINE_CHANGE_DATE, (event,args) => {this._reset(args.newDate, args.idHeader);});
  }

  _initComponentDays(){
    this.monthInDays = this._loadMonthDays(this.month,this.year);
    this.dayNameArray = this._loadDayNames(this.monthInDays);
  }

  _loadMonthDays(month,year) {
    let daysDateFormat = [];
    let daysInMonth = this.daysInMonth(month,year);
    for(let i = 1; i<=daysInMonth;i++){
      daysDateFormat.push(new Date(year,month,i));
    }
    return daysDateFormat;
  }

  _loadDayNames(monthDays){
    let dayNames = [];
    monthDays.forEach((day) => {
      dayNames.push(this.weekdays[day.getDay()]);
    });
    return dayNames;
  }

  _startWeekDayNames(){
    //TODO Ferran I18N
    let weekday = [];
    weekday[1] = 'Lu';
    weekday[2] = 'Ma';
    weekday[3] = 'Mi';
    weekday[4] = 'Ju';
    weekday[5] = 'Vi';
    weekday[6] = 'Sa';
    weekday[0] = 'Do';
    return weekday;
  }

  _reset(tempDate, id) {
    if(this.id) {
      let isNotCurrentCalendar = (!tempDate || id !== this.id[0]);
      if(isNotCurrentCalendar) {
        return;
      }
    }
    
    this.momentDate = moment(tempDate);
    this.momentDate.locale('es');
    this.monthName = this.momentDate.format('MMMM YYYY');
    this.month = tempDate.getMonth();
    this.year = tempDate.getFullYear();
    this._initComponentDays();
  }

  daysInMonth(month, year) {
    let TO_MONTH_0_BASED_ARRAY = 1 + month;
    return new Date(year,TO_MONTH_0_BASED_ARRAY, 0).getDate();
  }
}

export default CalendarInlineHeaderController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlineHeader/calendarInlineHeader.controller.js